import { render, staticRenderFns } from "./campanies.vue?vue&type=template&id=40be79ba"
import script from "./campanies.vue?vue&type=script&lang=js"
export * from "./campanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports